// Dependency-free inline SVG icon per conversation channel.
import type { ReactNode } from 'react';
import { CHANNEL_LABEL } from './convUtils';

export default function ChannelIcon({
  channel,
  size = 14,
  className = '',
}: {
  channel: string;
  size?: number;
  className?: string;
}) {
  let inner: ReactNode;
  if (channel === 'email') {
    inner = (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3 7 9 6 9-6" />
      </>
    );
  } else if (channel === 'call' || channel === 'voicemail') {
    inner = (
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.05 12.05 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.05 12.05 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    );
  } else {
    inner = <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role="img"
      aria-label={CHANNEL_LABEL[channel] || 'Message'}
    >
      {inner}
    </svg>
  );
}
